var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"cont",staticClass:"regionEditable"},[_c('canvas',{attrs:{"id":"fabricCanvas"}}),(_vm.canvas)?_c('FabricGuides',{attrs:{"canvas":_vm.canvas,"fz":_vm.fz}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }